import { applySnapshot, flow, types } from "mobx-state-tree";
import { ErrorModel } from "../../components/common/error";
import { IInput } from "../../utils/common-interface";
import customtypes from "../../utils/mobx-types-helper";
import permissionAPI from "./PermissionService";

export const UserPermissionModel = types
  .model("UserPermissionModel", {
    permissionCode: customtypes.optional(types.string, ""),
    permissionName: customtypes.optional(types.string, ""),
    permissionDetail: customtypes.optional(types.string, ""),
    isSelected: types.maybeNull(types.boolean),
  })
  .views((self: any) => ({}))
  .actions((self: any) => ({
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
  }));

export const PermissionModel = types
  .model("PermissionModel", {
    permissionGroupCode: customtypes.optional(types.string, ""),
    permissionGroupName: customtypes.optional(types.string, ""),
    permissionGroupDetail: customtypes.optional(types.string, ""),
    userPermissions: customtypes.optional(types.array(UserPermissionModel), []),
  })
  .views((self: any) => ({}))
  .actions((self: any) => ({
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
    setAllField: (data: any) => {
      Object.keys(data).forEach((key) => {
        try {
          self[key] = data[key];
        } catch (e) {
          console.log("exception on mapping key:", key);
        }
      });
    },
  }));

export const PermissionListModel = types
  .model("PermissionListModel", {
    list: customtypes.optional(types.array(PermissionModel), []),
    error: types.optional(ErrorModel, {}),
  })
  .views((self: any) => ({}))
  .actions((self: any) => ({
    getPermission: flow(function*() {
      try {
        const result = yield permissionAPI.getPermission();
        self.list = result.data;
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        //
      }
    }),
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
    setAllField: (data: any) => {
      Object.keys(data).forEach((key) => {
        try {
          self[key] = data[key];
        } catch (e) {
          console.log("exception on mapping key:", key);
        }
      });
    },
  }));

export type IPermissionListModel = typeof PermissionListModel.Type;
export type IUserPermissionModel = typeof UserPermissionModel.Type;
export type IPermissionModel = typeof PermissionModel.Type;
